import script from "./navigation-rail.vue?vue&type=script&lang=ts&setup=true"
export * from "./navigation-rail.vue?vue&type=script&lang=ts&setup=true"

import "./navigation-rail.vue?vue&type=style&index=0&id=23aa8b90&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23aa8b90"]])

export default __exports__